module.exports = __webpack_public_path__ + "img/duo_logo.17f241bb.svg";